export const fallbackProfile=[
  {
    id: 'profile',
    display_name: 'Dadda Cool',
    tagline: 'Links from the future',
    bio: 'AI music,creator gear,Amazon finds,and lifetime software deals. In collab with 8848 Stories/Toolaro. Every link supports the journey.',
    image_url: 'https://media-manager-c.questera.ai/greta-media/0b3af998e770acea81dd65e1f88cbe23e5433846e0d8905ff7ba265c9308956ef02252169608e8dd98a402f9c5748de4/images/aW1hZ2UvanBlZw==/c30ad2c1a0815da680924b1c44436cb2.jpeg'
  }
];

export const fallbackSocials=[
  {
    id: 'youtube-dadda-cool',
    platform: 'youtube',
    label: 'Dadda Cool on YouTube',
    url: 'https://www.youtube.com/@daddacool',
    order: 1,
    active: 'TRUE'
  },
  {
    id: 'youtube-toolaro',
    platform: 'youtube',
    label: 'Toolaro on YouTube',
    url: 'https://www.youtube.com/@toolaro',
    order: 2,
    active: 'TRUE'
  },
  {
    id: 'youtube-music-channel',
    platform: 'youtube',
    label: 'Dadda Cool Music on YouTube',
    url: 'https://www.youtube.com/channel/UCdmO4grcDHz64uR5MYR9hmg',
    order: 3,
    active: 'TRUE'
  },
  {
    id: 'tiktok-8848-stories',
    platform: 'tiktok',
    label: '8848 Stories on TikTok',
    url: 'https://www.tiktok.com/@8848stories',
    order: 4,
    active: 'TRUE'
  },
  {
    id: 'instagram-dadda-cool',
    platform: 'instagram',
    label: 'Dadda Cool on Instagram',
    url: 'https://www.instagram.com/dadda.cool',
    order: 5,
    active: 'TRUE'
  },
  {
    id: 'spotify-dadda-cool',
    platform: 'spotify',
    label: 'Dadda Cool on Spotify',
    url: 'https://open.spotify.com/artist/3HzPfRpKZpCFBloBv5SFbM',
    order: 6,
    active: 'TRUE'
  },
  {
    id: 'apple-music-dadda-cool',
    platform: 'apple_music',
    label: 'Dadda Cool on Apple Music',
    url: 'https://music.apple.com/au/artist/dadda-cool/1810865388',
    order: 7,
    active: 'TRUE'
  },
  {
    id: 'amazon-music-dadda-cool',
    platform: 'amazon_music',
    label: 'Dadda Cool on Amazon Music',
    url: 'https://music.amazon.com/artists/B0F6KQKY6H/dadda-cool',
    order: 8,
    active: 'TRUE'
  }
];

export const fallbackLinks=[
  {
    id: 'shop',
    title: 'Shop the latest drops',
    description: 'Gear,merch,and curated finds',
    url: 'https://shop.dadda.cool/',
    category: 'shop',
    featured: 'TRUE'
  },
  {
    id: 'music',
    title: 'Listen to my music',
    description: 'AI-driven tracks and sonic experiments',
    url: '#/music',
    category: 'music'
  },
  {
    id: 'portfolio',
    title: 'Explore my portfolio',
    description: 'Projects,videos,and digital builds',
    url: '#/portfolio',
    category: 'design'
  },
  {
    id: 'amazon-finds',
    title: 'Amazon Finds',
    description: 'Selected creator gear,desk upgrades and useful discoveries',
    url: '#/amazon-finds',
    category: 'amazon',
    featured: 'FALSE',
    archived: 'FALSE',
    order: 4
  },
  {
    id: 'support',
    title: 'Support the journey',
    description: 'Help fuel the next creative drop',
    url: 'https://buymeacoffee.com/daddacool',
    category: 'support'
  }
];

export const fallbackDeals=[
  {
    id: 'deal-1',
    title: 'Creator AI Toolkit',
    description: 'A hand-picked stack for faster creative work.',
    category: 'ai',
    price: 'Lifetime deal',
    url: 'https://shop.dadda.cool/',
    featured: 'TRUE'
  },
  {
    id: 'deal-2',
    title: 'Visual Design Bundle',
    description: 'Polished assets for digital creators.',
    category: 'design',
    price: 'Featured',
    url: 'https://shop.dadda.cool/'
  },
  {
    id: 'deal-3',
    title: 'Music Production Picks',
    description: 'Tools for beats,mixing,and mastering.',
    category: 'audio',
    price: 'Curated',
    url: 'https://shop.dadda.cool/'
  }
];

export const fallbackAmazonFinds=[
  {
    id: 'fallback-insta360-x6-essentials-bundle',
    title: 'Insta360 X6 Essentials Bundle',
    description: '8K 360° action camera with dual sensors, AI editing, and 10-bit color.',
    url: 'https://link.amazon/B0f5GJnqe',
    image_url: 'https://m.media-amazon.com/images/I/61rfMiVXd2L._AC_SX679_.jpg',
    category: 'Cameras',
    price_label: 'View on Amazon',
    featured: 'TRUE',
    active: 'TRUE',
    order: 1
  }
];

export const seedancePortfolioItem={
  id: 'fallback-seedance-prompts',
  title: 'Seedance Prompts',
  description: 'Create better AI videos with ready-to-copy Seedance prompts,step-by-step guides,and tips for cinematic scenes,product ads,and more.',
  category: 'Websites',
  subcategory: 'AI Prompts & Guides',
  type: 'website',
  url: 'https://seedanceprompts.netlify.app',
  featured: 'TRUE',
  order: 1
};

export const splitAudioPortfolioItem={
  id: 'fallback-split-audio',
  title: 'SplitAudio',
  description: 'A free,privacy-focused browser tool for cutting and extracting audio segments from MP3 and WAV files,with processing done entirely on your device.',
  category: 'Audio Tools',
  subcategory: 'Audio Editing',
  type: 'website',
  url: 'https://splitaudios.netlify.app/',
  featured: 'FALSE',
  order: 2
};

export const medExplainPortfolioItem={
  id: 'fallback-med-explain-gpt',
  title: 'MedExplainGPT',
  description: 'An AI-powered tool that explains complex medical reports in plain language,helping Australian patients understand medical terminology,test results,and prepare questions for their healthcare professionals while keeping report processing privacy-focused.',
  category: 'Health & Medical AI',
  subcategory: 'Medical Report Explainer',
  type: 'health-ai',
  url: 'https://medexplaingpt.netlify.app/',
  featured: 'FALSE',
  order: 3
};

export const barkDashPortfolioItem={
  id: 'fallback-barkdash',
  title: 'BARKDASH',
  description: 'A fast-paced pixel-art endless runner where you run,jump,slide,and bark your way through obstacles while collecting bones and chasing your best distance.',
  category: 'Games',
  subcategory: 'Endless Runner',
  type: 'browser-game',
  url: 'https://barkdashrunner.netlify.app/',
  featured: 'FALSE',
  order: 4
};

export const tikDownloadPortfolioItem={
  id: 'fallback-tikdownload',
  title: 'TikDownload',
  description: 'A fast,free TikTok downloader that lets users save TikTok videos without watermarks across phones,tablets,and computers,with support for photo slideshows.',
  category: 'Social Media Tools',
  subcategory: 'TikTok Downloader',
  type: 'social-media-tool',
  url: 'https://tokdownloader.netlify.app/',
  featured: 'FALSE',
  order: 5
};

export const mocksyPortfolioItem={
  id: 'fallback-mocksy',
  title: 'Mocksy',
  description: 'An AI-powered creative studio for generating realistic logo mockups,product shots,fashion photoshoots,ads,album covers,image restyles,consistent characters,and other branded visuals.',
  category: 'AI Image & Design Tools',
  subcategory: 'Creative Studio',
  type: 'ai-design-tool',
  url: 'https://mocksy.base44.app/',
  featured: 'FALSE',
  order: 6
};

export const qraiPortfolioItem={
  id: 'fallback-qrai',
  title: 'QRAI',
  description: 'A customizable QR code generator that turns any URL into branded QR codes with custom colors,frames,logos,call-to-action text,and multiple visual styles.',
  category: 'QR Code & Marketing Tools',
  subcategory: 'QR Code Generator',
  type: 'marketing-tool',
  url: 'https://qrai-generator.netlify.app/',
  featured: 'FALSE',
  order: 7
};

export const digitalResumeCreatorPortfolioItem={
  id: 'fallback-digital-resume-creator',
  title: 'Digital Resume Creator',
  description: 'A free online resume and CV builder for creating professional,ATS-friendly resumes with customizable templates,live preview,themes,and instant HTML export—without requiring sign-up.',
  category: 'Tools & Utilities',
  subcategory: 'Resume & CV Builder',
  type: 'productivity-tool',
  url: 'https://digitalresumecreator.netlify.app/',
  featured: 'FALSE',
  order: 8
};

export const portfolioChannels=[
  {
    id: 'fallback-8848-stories-tiktok',
    title: '8848 Stories on TikTok',
    description: 'Short-form stories,creative videos and visual experiments from 8848 Stories.',
    category: 'Channels',
    subcategory: 'TikTok',
    type: 'social-channel',
    url: 'https://www.tiktok.com/@8848stories',
    featured: 'FALSE',
    order: 9
  },
  {
    id: 'fallback-dadda-cool-youtube',
    title: 'Dadda Cool on YouTube',
    description: 'Videos covering AI creativity,music,digital tools and Dadda Cool projects.',
    category: 'Channels',
    subcategory: 'YouTube',
    type: 'social-channel',
    url: 'https://youtube.com/@daddacool?sub_confirmation=1',
    featured: 'FALSE',
    order: 10
  },
  {
    id: 'fallback-8848-stories-youtube',
    title: '8848 Stories on YouTube',
    description: 'Storytelling,creative productions and original videos from 8848 Stories.',
    category: 'Channels',
    subcategory: 'YouTube',
    type: 'social-channel',
    url: 'https://youtube.com/@8848stories?sub_confirmation=1',
    featured: 'FALSE',
    order: 11
  },
  {
    id: 'fallback-toolaro-youtube',
    title: 'Toolaro on YouTube',
    description: 'Discover useful digital tools,AI workflows and practical creator resources.',
    category: 'Channels',
    subcategory: 'YouTube',
    type: 'social-channel',
    url: 'https://youtube.com/@toolaro?sub_confirmation=1',
    featured: 'FALSE',
    order: 12
  }
];

export const fallbackPortfolio=[
  seedancePortfolioItem,
  splitAudioPortfolioItem,
  medExplainPortfolioItem,
  barkDashPortfolioItem,
  tikDownloadPortfolioItem,
  mocksyPortfolioItem,
  qraiPortfolioItem,
  digitalResumeCreatorPortfolioItem,
  ...portfolioChannels
];

export const fallbackMusic=[
  {
    id: 'track-1',
    title: 'Neon Memory',
    artist: 'Dadda Cool',
    platform: 'Spotify',
    url: 'https://open.spotify.com/artist/3HzPfRpKZpCFBloBv5SFbM'
  },
  {
    id: 'track-2',
    title: 'Machine Dreams',
    artist: 'Dadda Cool',
    platform: 'Apple Music',
    url: 'https://music.apple.com/au/artist/dadda-cool/1810865388'
  },
  {
    id: 'track-3',
    title: 'After the Algorithm',
    artist: 'Dadda Cool',
    platform: 'Amazon Music',
    url: 'https://music.amazon.com/artists/B0F6KQKY6H/dadda-cool'
  }
];